import styled, { css } from 'styled-components';
import { cssfonts, pxToCssFont } from '@vfit/shared/themes';
import { IFrameDateInputForStyled } from './frameDateInput.models';

const variants = {
  timeRange: {
    long: css`
      ${pxToCssFont(28, 36)}
    `,
    short: css`
      ${pxToCssFont(16, 22)}
      flex-grow: 1;
      text-align: center;
    `,
  },
};

export const Day = styled.h5`
  ${cssfonts.regular}
  ${pxToCssFont(22, 32)}
  margin: 0;
`;

export const TimeRange = styled.h4<IFrameDateInputForStyled>`
  ${cssfonts.exbold}
  margin: 0;
  ${({ variant }) => (variant ? variants.timeRange[variant] : '')}
`;

